import { useQuery } from 'react-query'
import { fetchListingIntakeCounts, listingIntakesQueryKey } from '@/pages/RealState/api/listingIntakes'

const COUNTS_REFRESH_MS = 60_000

export function useListingIntakeCounts(enabled = true) {
  return useQuery(listingIntakesQueryKey.counts, fetchListingIntakeCounts, {
    enabled,
    staleTime: 30_000,
    refetchInterval: enabled ? COUNTS_REFRESH_MS : false,
    retry: false
  })
}
